<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <div>
        <el-select v-model="reachUser.utype" @clear="initUser" placeholder="请选择用户类别"
                   style="margin-right: 10px;">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
<!--        <el-input style="width: 300px;margin-right: 10px;" prefix-icon="el-icon-search"-->
<!--                  v-model="reachUser.username"-->
<!--                  @keydown.enter.native="initUser"-->
<!--                  placeholder="请输入用户名(非用户昵称)进行搜索" clearable @clear="initUser"></el-input>-->

        <el-input style="width: 300px;margin-right: 10px;" prefix-icon="el-icon-search"
                  v-model="reachUser.nickname"
                  @keydown.enter.native="initUser"
                  placeholder="请输入用户昵称进行搜索" clearable @clear="initUser"></el-input>
        <el-select v-model="reachUser.schoolId" clearable @clear="initUser" placeholder="请选择学校"
                   style="margin-right: 10px;">
          <el-option
              v-for="item in schools"
              :key="item.value"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="initUser">搜索</el-button>
      </div>
    </div>
    <div style="margin-top: 30px;">
      <el-table
          v-loading="loading"
          :data="users"
          border
          style="width: 100%">
        <el-table-column
            label="头像" width="60">
          <template slot-scope="scope">
            <div class="demo-type">
              <div>
                <el-avatar :src="scope.row.avatarUrl"></el-avatar>
              </div>
            </div>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--            prop="username"-->
<!--            label="用户名"-->
<!--            width="200">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="email"-->
<!--            label="邮箱"-->
<!--            width="200">-->
<!--        </el-table-column>-->
        <el-table-column
            prop="nickname"
            label="昵称"
            width="200">
        </el-table-column>
        <el-table-column
            prop="schoolName"
            label="学校"
            width="200">
        </el-table-column>
        <el-table-column
            prop="intro"
            label="认证信息"
            width="250">
        </el-table-column>
        <el-table-column

            label="操作"
            width="200">
          <template slot-scope="scope">
            <el-button type="success" @click="showAddMessage(scope.row.id)">发布通知</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;display: flex;justify-content: space-between">
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="sizes,prev, pager, next, jumper, ->, total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="发布消息"
        :visible.sync="addMessageDialogVisible"
        width="70%">
      <div>
        <el-form ref="addMessageForm" :model="addMessage" :rules="messageRules">
          <el-form-item label="标题" prop="title">
            <el-input style="width: 500px" v-model="addMessage.title"
                      placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item prop="content">
            <vue-tinymce
                v-model="addMessage.content"
                :setting="setting"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="addMessageDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveMessage()">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'NoticeTo',
  data() {
    return {
      options: [{
        value: -1,
        label: '全部'
      }, {
        value: 0,
        label: '普通用户'
      }, {
        value: 1,
        label: '校园号'
      }],
      headers: {
        Authorization: window.sessionStorage.getItem('tokenStr')
      },
      users: [],
      schools: [],
      loading: false,
      total: 0,
      currentPage: 1,
      size: 10,
      userName: '',
      reachUser: {
        username: '',
        nickname:'',
        utype: -1,
        schoolId: ''
      },
      setting: {
        convert_urls: false,
        menubar: true,
        toolbar: "undo redo| preview | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat | importword | kityformula-editor | hr | directionality | indent2em | lineheight | importcss",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "preview link image media table lists fullscreen quickbars code codesample importword imagetools kityformula-editor hr directionality indent2em lineheight importcss",
        //  images_upload_url: '/editor/upload',
        //  images_upload_base_path: this.GLOBAL.serverUrl+'/',
        images_upload_credentials: true,
        language: 'zh_CN', //本地化设置
        height: 500,
        images_upload_handler: (blobInfo, succFun, failFun) => {
          var serverUrl = this.GLOBAL.serverUrl
          var xhr, formData;
          var file = blobInfo.blob();//转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', '/api/editor/upload'); //this.GLOBAL.serverUrl+
          xhr.setRequestHeader('Authorization', window.sessionStorage.getItem('tokenStr'))
          xhr.onload = function () {
            var json;
            if (xhr.status != 200) {
              failFun('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.location != 'string') {
              failFun('Invalid JSON: ' + xhr.responseText);
              return;
            }
            var path = serverUrl + json.location
            // var path =  json.location
            succFun(path);
          };
          // this.uploadPostRequest('/editor/upload',file).then(resp=>{
          //   if(resp){
          //     succFun(resp.location)
          //   }
          // })
          formData = new FormData();
          formData.append('file', file, file.name);//此处与源文档不一样
          xhr.send(formData);
        }
      },
      addMessage:{
        title:'',
        content:'',
        toUserId:''
      },
      // dialogVisible: false,
      addMessageDialogVisible: false,
      title: '',
      messageRules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: blur
        }],
        content: [{
          required: true,
          message: '请输入消息内容',
          trigger: blur
        }]
      },
    }
  },
  mounted() {
    this.initUser()
    this.initSchool()
  },
  methods: {
    initSchool() {
      this.getRequest("/school/").then(resp => {
        if (resp) {
          this.schools = resp
        }
      })
    },
    showAddMessage(id) {
      this.addMessage = {
        toUserId: id,
        title: '',
        content: ''
      }
      this.addMessageDialogVisible = true;
    },
    sizeChange(size) {
      this.size = size
      this.initUser()
    },
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.initUser()
    },
    initUser() {
      this.loading = true
      this.postRequest('/message/web/userList?currentPage=' + this.currentPage + '&size=' + this.size, this.reachUser).then(resp => {
        this.loading = false
        if (resp) {
          this.users = resp.data
          this.total = resp.total
        }
      })
    },
    saveMessage() {
      this.$confirm('确定发布此消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs['addMessageForm'].validate(valid => {
          if (valid) {
            this.postRequest('/message/web/to', this.addMessage).then(resp => {
              if (resp) {
                this.addMessageDialogVisible = false
              }
            })
          } else {
            this.$message('标*字段不能为空')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
  }
}
</script>

<style scoped>

</style>
